export const SEATS_VERSIONS_FEATURE_FLAG = 'SEATS_VERSIONS_FEATURE_FLAG';
export const SSM_JUNE_24_PRICE_CHANGES_FLAG = 'SSM_JUNE_24_PRICE_CHANGES_FLAG';
export const SSM_OFFER_UTILS_REFACTOR_FLAG = 'SSM_OFFER_UTILS_REFACTOR_FLAG';
export const SSM_OFFER_HELPER_UTILS_REFACTOR_FLAG = 'SSM_OFFER_HELPER_UTILS_REFACTOR_FLAG';